import '../../../../Assets/style/components/chat.scss'
import {
  Stack
} from "@mui/material";
import { Hourglass } from "react-loader-spinner";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  const { data, contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
    contactList: contactListData.contactList,
    cannedmessagediv: data.cannedmessagediv,
    contactlistLoader: contactListData.contactlistLoader,
  };
};

const SmartAssist = (props) => {

  
  return (
    <>
      <div className="h-100 overflow-auto">
        <div className="container-fluid h-100">
          <div className="row row-cols-1">
            <div className="col p-1 "style={{height:'43vh'}}>
              <div className="card1 h-100 mx-auto" >
             

                {/* <div className="bg"> */}
                  <div className="row w-100 h-100">
                    {props.smartxdataloader?
                    <Stack sx={{ position: "relative", top: "50%", left: "50%" }}>
                    <Hourglass
                      visible={true}
                      height="30"
                      width="30"
                      ariaLabel="hourglass-loading"
                      wrapperStyle={{}}
                      wrapper
                      colors={["#2268a0", "#72a1ed"]}
                    />
                  </Stack>
                  :  
                  <>
                     <div className="col-md-6 my-auto">
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Request Id</div>
                        <div>{props.smartxdata?props.smartxdata.requestId:''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Sla Breach</div>
                        <div>{props.smartxdata?props.smartxdata.slaBreach==true?
                      <span className="priority">
                        <span className="badge" style={{backgroundColor:"red"}}>True</span>
                      </span>
                        :props.smartxdata.slaBreach==false?
                        <span className="priority">
                        <span className="badge" style={{backgroundColor:"green"}}>False</span>
                      </span>
                        :'N/A':''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Created Time</div>
                        <div>{props.smartxdata.createdTime?props.smartxdata.createdTime.display_value:'--'}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">FirstResponseDueByTime</div>
                        <div>{props.smartxdata.firstResponseDueByTime?props.smartxdata.firstResponseDueByTime.display_value:''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Priority</div>
                        {props.smartxdata.priority && props.smartxdata.priority.name=="Low"?
                        <div className="d-flex justify-content-center align-items-center">
                        <span className="priority">
                            <span className="badge" style={{backgroundColor:"green"}}>{props.smartxdata.priority?props.smartxdata.priority.name:''}</span>
                          </span>
                        </div>:props.smartxdata.priority && props.smartxdata.priority.name=="Medium"?
                          <div>
                                <span className="priority">
                                <span className="badge" style={{backgroundColor:"#1574d5"}}>{props.smartxdata.priority?props.smartxdata.priority.name:''}</span>
                              </span>
                            </div>:props.smartxdata.priority && props.smartxdata.priority.name=="High"?
                                     <div>
                                     <span className="priority">
                                     <span className="badge" style={{backgroundColor:"red"}}>{props.smartxdata.priority?props.smartxdata.priority.name:''}</span>
                                   </span>
                                 </div>:''

                        }
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Resolved Time</div>
                        <div>{props.smartxdata.resolvedTime?props.smartxdata.resolvedTime.display_value:''}</div>
                      </div>

                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Status</div>
                        <div>{props.smartxdata.status?props.smartxdata.status.name:''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Last Updated Time</div>
                        <div>{props.smartxdata.lastUpdatedTime?props.smartxdata.lastUpdatedTime.display_value:''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Due By Time</div>
                        <div>{props.smartxdata.dueByTime?props.smartxdata.dueByTime.display_value:''}</div>
                      </div>
                    </div>
                    <div className="col-md-6 my-auto">
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Cancel Requested Time</div>
                        <div>{props.smartxdata?props.smartxdata.cancelRequestedTime??'N/A':''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Reason For Cancel</div>
                        <div>{props.smartxdata?props.smartxdata.reasonForCancel??'N/A':''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Completed Time</div>
                        <div>{props.smartxdata.completedTime?props.smartxdata.completedTime.display_value:''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Subject</div>
                        <div>{props.smartxdata?props.smartxdata.subject:''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Technician</div>
                        <div>{props.smartxdata.technician?props.smartxdata.technician.name??"N/A":''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Account</div>
                        <div>{props.smartxdata.account?props.smartxdata.account.name:''}</div>
                      </div>

                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Scheduled End Time</div>
                        <div>{props.smartxdata.scheduledEndTime?props.smartxdata.scheduledEndTime.display_value:''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Category</div>
                        <div>{props.smartxdata.category?props.smartxdata.category.name:''}</div>
                      </div>
                      <div className="d-flex justify-content-between p-1">
                        <div className="fw-bold">Csatscore</div>
                        <div>{props.smartxdata.csatscore}</div>                      
                      </div>
                    </div> 
                  </>
                  }
                  </div>
                {/* </div> */}
                {/* <div
                  className="blob"
                  style={{
                    backgroundColor:props.smartxdata?props.smartxdata.slaBreach==true?"red":props.smartxdata.slaBreach==false?'green':'':''
                  }}
                ></div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// export default SmartAssist;

export default connect(mapStateToProps, {},)(SmartAssist);
